var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.911 4.356 11.203.047h-.406L2.088 4.356l-.255.41v12.468l.256.41 8.708 4.309h.406l8.709-4.309.255-.41V4.766l-.256-.411zM11 .97l7.767 3.843L11 8.655 3.233 4.813 11 .97zM2.75 5.597l7.792 3.854v11.353L2.75 16.949V5.597zm8.708 15.207V9.45l7.792-3.854v11.352l-7.792 3.855z",
  fill: "#031434"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m7.153 12.532.996-1.246-.357-.744h-2.75v.917h1.796l-.871 1.088.358.745h.092a.918.918 0 0 1 0 1.833.918.918 0 0 1-.917-.916h-.917c0 1.01.823 1.833 1.834 1.833a1.835 1.835 0 0 0 1.833-1.833c0-.75-.452-1.392-1.097-1.677zM15.125 10.542H13.75v5.5h1.375a1.835 1.835 0 0 0 1.833-1.833v-1.834a1.835 1.835 0 0 0-1.833-1.833zm.917 3.667a.918.918 0 0 1-.917.916h-.458V11.46h.458c.505 0 .917.41.917.916v1.834z",
  fill: "#031434"
});

function SvgRtrEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtrEnabled);
export default __webpack_public_path__ + "static/media/rtr-enabled.b7035a65.svg";
export { ForwardRef as ReactComponent };